<div class="login-container">
  <form [formGroup]="forgotPasswordForm">
    <img src="./assets/images/logo-bo-new-gen.png" alt="" height="32" width="109">
    <div class="box-center">
      <span>ลืมรหัสผ่าน ?</span>
      <span>กรุณากรอก อีเมล ที่ลงละเบียน<br>
        ระบบจะส่ง ลิงค์ ตั้งค่ารหัสผ่านใหม่ ไปที่ อีเมล ของคุณ</span>
    </div>
    <div class="not-match" *ngIf="loginfails">
      <div>
        <span><img src="/assets/images/icon-valid.png" alt="" height="16" width="16"></span>
        ไม่พบ E-mail ในระบบ! กรุณากรอก E-mail ใหม่อีกครั้ง
      </div>
    </div>
    <div class="form-group mb-4">
      <label for="email">อีเมล</label>
      <input type="email" id="email" formControlName="email" placeholder="กรอก E-mail">
    </div>
    <button type="submit" class="btn btn-primary login-button" (click)="onSubmit()" [disabled]="forgotPasswordForm.invalid">ยืนยัน</button>
    <a class="btn c-primary" [routerLink]="'/auth/login'">
      <img src="./assets/images/arrow-left.png" alt="" height="16" width="16" style="margin-right: 4px;"> <span>กลับไปหน้าเข้าสู่ระบบ</span>
    </a>
    <!-- <button class="btn btn-forgot" [routerLink]="'/auth/login'"><img src="./assets/images/icon-arrow-left-blue.png" alt="" height="12" width="7"><span>กลับไปหน้าเข้าสู่ระบบ</span></button> -->
  </form>
</div>